import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { sendTeaCommEvent } from 'lib/tea-analyze'

export default function Title() {
  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  })

  useEffect(() => {
    if (inView) {
      sendTeaCommEvent('show_event', {
        event_id: 'common_conponent_module',
        module_id: 'dscore_module',
      })
    }
  }, [inView])
  return (
    <span
      ref={ref}
      className="text"
      onClick={() => {
        sendTeaCommEvent('clk_event', {
          event_id: 'dscore_module_title',
          module_id: 'dscore_module',
        })
      }}
    >
      每次评分都源自一次真实的体验
    </span>
  )
}
